module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "am-container"
  }, [_vm._v("Amazevue " + _vm._s(_vm.version) + " (c) " + _vm._s(new Date().getFullYear()) + " Tidyzq")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd23370a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./doc/components/MainFooter.vue
// module id = 88
// module chunks = 2